declare global {
  interface Window {
    ciq?: {
      enabledFeatureFlags?: string[];
    };
    DD_RUM?: Record<string, any>;
  }
}

export const FEATURE_FLAG_AGENT_CHARTING = 'feature_flag_agent_charting';
export const FEATURE_FLAG_AI_COMP_ADMIN_AGENT = 'feature_flag_ai_comp_admin_agent';
export const FEATURE_FLAG_AI_SHELL_FILE_UPLOAD = 'feature_flag_ai_shell_file_upload';

export const isFeatureEnabled = (flagName: string): boolean => {
  return window.ciq?.enabledFeatureFlags?.includes(flagName) ?? false;
};
